__turbopack_context__.v({
  "fadeUp": "WhatYouGet-module__BRAZdq__fadeUp",
  "grid": "WhatYouGet-module__BRAZdq__grid",
  "iconImage": "WhatYouGet-module__BRAZdq__iconImage",
  "iconWrapper": "WhatYouGet-module__BRAZdq__iconWrapper",
  "inner": "WhatYouGet-module__BRAZdq__inner",
  "item": "WhatYouGet-module__BRAZdq__item",
  "itemCaption": "WhatYouGet-module__BRAZdq__itemCaption",
  "itemTitle": "WhatYouGet-module__BRAZdq__itemTitle",
  "muteButton": "WhatYouGet-module__BRAZdq__muteButton",
  "placeholderInside": "WhatYouGet-module__BRAZdq__placeholderInside",
  "section": "WhatYouGet-module__BRAZdq__section",
  "textStack": "WhatYouGet-module__BRAZdq__textStack",
  "title": "WhatYouGet-module__BRAZdq__title",
  "video": "WhatYouGet-module__BRAZdq__video",
  "videoFrame": "WhatYouGet-module__BRAZdq__videoFrame",
});
